export const unionEndWith = (origin: string, strList: string[]) =>
  !strList.every(v => !origin.endsWith(v));

export const isImg = (org: string) =>
  unionEndWith(org, ["png", "jpg", "jpeg", "ai", "ico"]);
